module.exports = __webpack_public_path__ + "static/media/bath.def85944.svg";